import { Tooltip } from '@mui/material';
import ServerDataGrid from 'views/pages/manage/common/data-grid/ServerDataGrid';
import React, { useState } from 'react';
import ReminderDialog from './ReminderDialog';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as PhoneIcon } from 'assets/img/svg/PhoneList.svg';
import { openInNewTab } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { STUDENT_OUTSTANDING_DETAILS } from 'views/pages/manage/edpOps/studentDetails/constant';
import { useNavigateToGivenPath } from 'views/pages/manage/edpOps/studentDetails/paymentSummary/service';
import { statusColors } from './constant';
import CustomChip from 'views/pages/manage/common/customChip/CustomChip';
import { formatDate } from 'modules/studentRefund/studentRefundRequest/multiTypeRefund/utils';
import { formattedPrice } from 'views/pages/manage/unAssigned/collectPayment/utils';
import { linkButtonStyles } from 'views/pages/manage/edpOps/constant/student-details';

const ListComponent = (
  {
    getOutstandingList,
    rows,
    handleContactDetailsOpen,
    setDialogOpen,
    setEditingRow,
    paginationInfo,
    tabKey
  }
) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  // { [rowId]: { remarks, reminderDate } }
  const navigateToGivenPath = useNavigateToGivenPath();
  const columns = [
    {
      key: "psid",
      label: "PSID",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div
              onClick={() => { navigateToGivenPath(`admin/edp/studentDetails/${value}`) }}
              style={{ color: "#00B0F5", cursor: "pointer" }}
              className="ellipsis-text-container">{value}</div></Tooltip>) : <div>-</div>
    },
    {
      key: "applicationId",
      label: "App Id.",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <span>{value}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "studentName",
      label: "Student Name",
      sortable: true,
      width: 120,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container d-flex align-items-center" style={{ gap: '7px' }}>
              <span
              className='cursor'
                onClick={(e) => {
                  e.stopPropagation();
                  handleContactDetailsOpen(row)
                }}>
                <PhoneIcon />
              </span>
              <span>
                {value}
              </span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "businessArea",
      label: "Bu Code",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <span>{value}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "cashierOffice",
      label: "Cashier Office",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <span>{value}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "term",
      label: "Term ",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              {value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "programAction",
      label: "Status ",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <CustomChip {...statusColors[value] || value} />
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "followUpDate",
      label: "Follow Up Date",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={formatDate(value)}>
            <div className="ellipsis-text-container">
              <span className='color-red-60'>{formatDate(value)}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    ...(tabKey !== "TO_BE_FOLLOW_UP"?[{
      key: "discDate",
      label: "Disc Date",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={formatDate(value)}>
            <div className="ellipsis-text-container">
              <span className='color-red-60'>{formatDate(value)}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    }]:[]),
    {
      key: "outstandingAmount",
      label: "Outstanding Amt.",
      sortable: true,
      align: "right",
      width: 120,
      render: (value) => {
        const hasValue = value !== null && value !== undefined && value !== '';
        return hasValue ? (
          <Tooltip title={formattedPrice(value)}><div className="ellipsis-text-container">
            <div className="amount">{formattedPrice(value)}</div>
          </div></Tooltip>) : <div>-</div>
      }
    },
    {
      key: "remarks",
      label: "Remarks",
      sortable: true,
      width: 120,
      render: (value, row) => {
        const btnLabel = value ? 'View & Edit' : 'Add';
        return (
          <div>
            <div className="ellipsis-text-container mb-1"
              style={linkButtonStyles}
              onClick={() => {
                setEditingRow(row);
                // normalize date to YYYY-MM-DD if present
                setDialogOpen({ remarks: value, reminderDate: row?.reminderDate ? new Date(row.reminderDate) : null });
              }}
            >
              {btnLabel}
            </div>
          </div>
        );
      }
    },
    {
      key: "reminderDate",
      label: "Reminder Date",
      sortable: true,
      width: 120,
      render: (value, row) => {
        return value ? (
          <Tooltip title={formatDate(value)}>
            <div className="ellipsis-text-container">
              <span>{formatDate(value)}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        );
      }
    },
    {
      key: "actions",
      label: "Action",
      width: 120,
      pinned: true,
      render: (_, row) => {

        return (
          <div className="d-flex align-items-center">

            <AButton
              variant="primary_filled"
              onClick={() => {
                navigateToGivenPath(`admin/edp/studentDetails/${row?.psid}?source=${STUDENT_OUTSTANDING_DETAILS}`);
              }}
              size="xs"
            >
              Payment Details
            </AButton>
          </div>
        );
      }
    }
  ];

  const pagination = {
    page: (paginationInfo?.currPageNo ?? 0) + 1,
    pageSize: paginationInfo?.currPageSize || 50,
    total: paginationInfo?.totalRecords || 0,
    totalPages: paginationInfo?.totalPage || 0
  };


  // --- Handlers ---
  const handlePageChange = (newPage) => {
    const offset = newPage - 1;

    getOutstandingList({
      pageNo: offset,
      pageSize: pagination.pageSize
    });
  };

  const handlePageSizeChange = (newSize) => {
    getOutstandingList({ pageNo: 0, pageSize: newSize });
  };

  return (
    <>
      <ServerDataGrid
        rows={rows || []}
        loading={false} // Loading handled by ALoader above, so we don't double spin

        // Configuration
        columns={columns}
        rowKey="id" // Assuming your data has an 'id' field. If not, pass a function or unique key.

        pageSizeOptions = {[50, 100, 200, 300]}
        pagination={pagination}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        sortConfig={sortConfig}
        onSortChange={(key, direction) => setSortConfig({ key, direction })}
      />

    </>
  )
}

export default ListComponent
